'use strict';

angular.module('docketbook').
  controller('editUserGroupRolesModalController', function(addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, userService) {
  
    $scope.member = {}
    $scope.originalRoles = []
    $scope.activeRoles = []
    $scope.wasMonitor = false
    $scope.wasAdmin = false
    $scope.monitor = false
    $scope.admin = false
    $scope.saving = false
    $scope.allRoles = []
    $scope.group = {}

    
    $scope.$parent.showEditUserGroupRolesModal = function(member, group) {
        $scope.saving = false
        $scope.member = member
        $scope.group = group
        
        $scope.admin = group.owners.map(m => m.id).includes(member.id)
        $scope.wasAdmin = $scope.admin
        
        $scope.superUser = member.isGlobalAdmin

        $scope.allRoles = []
        $scope.roleDict = {}

        userService.getRoles(null, function(roles) {
            $scope.allRoles = roles
            roles.forEach(role => $scope.roleDict[role.id] = role)
        }, function(err) {
            $scope.allRoles = []
        })

        $scope.groupDict = {}
        $scope.currentOrg.groups.forEach(group => {
            $scope.groupDict[group.id] = group
        })

        $("#editUserGroupRolesModal").fadeIn(100)

        userService.getOrganisationGroup(group.id, function(groupFull) {
            $scope.activeRoles =
                groupFull.members
                .filter(m => m.user.id == $scope.member.id)
                .map(m => m.role)

            $scope.originalRoles = $scope.activeRoles.slice()

            $scope.monitor = groupFull.monitors.map(m => m.id).includes($scope.member.id)
            $scope.wasMonitor = $scope.monitor
        }, function(err) {
            $scope.alertService.presentAutoAlert('getOrgGroup', err)
        })
    }

    $scope.hasRole = function(role) {
        return $scope.activeRoles.map(r => r.id).includes(role.id)
    }

    $scope.toggleRole = function(role) {
        const remove = $scope.hasRole(role)
        if (remove) {
            $scope.activeRoles = $scope.activeRoles.filter(r => r.id != role.id)
        } else {
            $scope.activeRoles.push(role)
        }
    }

    $scope.cancel = function() {
        $("#editUserGroupRolesModal").fadeOut(100)
    }

    $scope.removeUser = function() {
        swal({
			title: "Remove Member",
			text: `Are you sure you wish to remove {member.name} entirely from the company?`,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#DD6B55",
			confirmButtonText: "Confirm",
			cancelButtonText: "Cancel",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function(isConfirm){
			if (isConfirm) {
                var groupsToRemove = $scope.originalMemberships.map(m => m.groups[0])
                const removeOneGroup = () => {
                    if (groupsToRemove.length == 0) {
                        $("#editUserGroupRolesModal").fadeOut(100)
                        return;
                    }
                    const groupToRemove = groupsToRemove.pop()
                    userService.removeMemberFromGroup(groupToRemove, $scope.member.id, removeOneGroup, function(err) {
                        $scope.alertService.presentAutoAlert('removeGroupMember', err);
                        removeOneGroup()
                    });
                }
            }
        });
    }

    $scope.toggleAdmin = function() {
        $scope.admin = !$scope.admin
    }

    $scope.toggleMonitor = function() {
        $scope.monitor = !$scope.monitor
    }

    const checkMonitorEdit = function() {
        return $q((pass, fail) => {
            if ($scope.monitor != $scope.wasMonitor) {
                if ($scope.monitor) {
                    var person = [ {user: $scope.member.id, roles: [ 'monitor' ]} ]
                    userService.assignMembersToGroup($scope.group.id, person, pass, fail)
                } else {
                    userService.removeMonitorFromGroup($scope.group.id, $scope.member.id, pass, fail)
                }
            } else {
                pass()
            }
        })
    }

    const checkAdminEdit = function() {
        return $q((pass, fail) => {
            if ($scope.admin != $scope.wasAdmin) {
                if ($scope.admin) {
                    const person = [ {user: $scope.member.id, roles: ['owner']} ]
                    userService.assignMembersToGroup($scope.group.id, person, pass, fail)
                } else {
                    userService.removeOwnerFromGroup($scope.group.id, $scope.member.id, pass, fail)
                }
            } else {
                pass()
            }
        })
    }

    $scope.saveUser = function() {

        var failures = []

        checkMonitorEdit().then(() => {
            checkAdminEdit().then(() => {
                
                var individualAdds = _.without($scope.activeRoles.map(r => r.id), ...$scope.originalRoles.map(r => r.id))
                var individualDeletes = _.without($scope.originalRoles.map(r => r.id), ...$scope.activeRoles.map(r => r.id))

                const removeOneMembership = () => {
                    if (individualDeletes.length <= 0) { 
                        $("#editUserGroupRolesModal").fadeOut(100)
                        $scope.$parent.editOrgGroup($scope.group)
                        return
                    }

                    const toRemove = individualDeletes.pop()
                    userService.removeMemberRoleFromGroup($scope.group.id, $scope.member.id, toRemove, removeOneMembership, err => { 
                        failures.push(err)
                        removeOneMembership()
                    })
                }

                const addOneMembership = () => {
                    if (individualAdds.length <= 0) { 
                        return removeOneMembership()
                    }

                    const toAdd = individualAdds.pop()
                    const memberAdd = { user: $scope.member.id, role: toAdd }
                    userService.addMemberToGroup($scope.group.id, memberAdd, addOneMembership, err => { 
                        failures.push(err)
                        addOneMembership() 
                    })
                }
                addOneMembership()
            })
        })
    }
    
    $scope.addMembership = function() {
        $scope.groupsMemberships.push({ groups: [], role: {}, edit: true })
    }

})


// WEBPACK FOOTER //
// ./src/controllers/modals/editUserGroupRolesModalController.js